import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Box } from '@quarkly/widgets';

var Stack = function Stack(_ref) {
  var gap = _ref.gap,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["gap", "children"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    margin: "calc(".concat(gap, " * -0.5)")
  }, rest), React.Children.map(children, function (child) {
    return React.isValidElement(child) ? React.cloneElement(child, {
      gap: gap
    }) : child;
  }));
};

Stack.propInfo = {
  gap: {
    weight: '1',
    control: 'input',
    library: 'components.stack.gap',
    transformer: 'pixel',
    category: 'Main'
  }
};
Stack.defaultProps = {
  gap: '--cmp-stack-gap-default',
  display: 'flex',
  'flex-wrap': 'wrap'
};
Stack.effects = {
  hover: ':hover'
};
export default Stack;